<div class="header">
  <div class="ghost-circle"></div>
  <div class="ghost-row"></div>
</div>

<div class="section">
  <div class="ghost-row"></div>
  <div class="ghost-row"></div>
  <div class="ghost-row"></div>
</div>

<div class="footer">
  <span class="ghost-row"></span>
  <div class="footer-circles">
    <div class="ghost-circle"></div>
    <div class="ghost-circle"></div>
    <div class="ghost-circle"></div>
    <u-icon [model]="{ type: 'font', value: 'icon-star-solid' }" [styles]="{ color: 'var(--color-border)' }"></u-icon>
  </div>
</div>
